import { RefObject } from "react";
import { useOutletContext } from "react-router-dom";
import { useLegacyIframe } from "@features/builddocs-iframe";
import { routes } from "@shared/lib/react-router";

export function ProfilePage() {
  const { wrapperRef } = useOutletContext() as {
    wrapperRef: RefObject<HTMLDivElement>;
  };

  useLegacyIframe({
    parentRef: wrapperRef,
    route: routes.profile(),
  });

  return <></>;
}
